export const OVERAGE_STATUS = {
  ALL_DISABLE: 0x00,
  BILLABLE_ENABLE: 0x01,
  SYSTEM_ENABLE: 0x02,
  ALL_ENABLE: 0x03,
};
